<template>
  <footer class="footer px-4 mx-2">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} Copyright: <a href="https://www.yoursynchronicity.com"
                                   class="font-weight-bold ml-1" target="_blank">BranchofApp </a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="https://www.yoursynchronicity.com" class="nav-link"
               target="_blank">BranchofApp</a>
          </li>
          <li class="nav-item">
            <a href="https://www.yoursynchronicity.com/terms" class="nav-link"
               target="_blank">Terms</a>
          </li>
          <li class="nav-item">
            <a href="https://www.yoursynchronicity.com/privacy" class="nav-link" target="_blank">Privacy
              Policy</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
    export default {
        data() {
            return {
                year: new Date().getFullYear()
            };
        }
    };
</script>
<style></style>
